import React, { createContext, useContext, useState } from 'react';

const HeaderContext = createContext();

export const useHeader = () => useContext(HeaderContext);

export const HeaderProvider = ({ children }) => {
    const [showHeader, setShowHeader] = useState(true);
    return (
        <HeaderContext.Provider value={{ showHeader, setShowHeader }}>
            {children}
        </HeaderContext.Provider>
    );
};